<template>
    <v-container grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12>
                <v-container grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs7>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light">Department List ({{ $format.int(pager.totalRecords) }})</h1>
                                <v-tooltip right>
                                    <template>
                                        <v-btn slot="activator" flat icon color="accent" class="mt-2" @click="onItemAdd"><v-icon>add_circle</v-icon></v-btn>
                                    </template>
                                    <span>Add a new department</span>
                                </v-tooltip>
                            </v-layout>
                        </v-flex>
                        <v-flex xs5>
                            <v-layout align-center justify-end row fill-height>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="toggleSearchAt">
                                            <v-icon>{{ searchAt.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Match search text at this position</span>
                                </v-tooltip>
                                <v-text-field ref="search" v-model="searchText" placeholder="Type here to filter the list" :hint="`(${searchAt.text}) Department Name`" persistent-hint prepend-icon="search" clearable @keyup.native="searchChange" @click:clear="searchChange"></v-text-field>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-card>
                                <v-data-table :headers="headers" :items="tableData" :loading="isBusy" hide-actions>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>{{ props.item.Name }}</td>
                                            <td class="justify-center layout px-0">
                                                <v-icon small class="mr-2" @click="onItemEdit(props.index, props.item)">edit</v-icon>
                                                <v-icon small @click="onItemDelete(props.index, props.item)">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>No data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left">
                                        <v-pagination v-model="pager.currentPage" :length="pager.pages" :total-visible="5" @next="loadData" @previous="loadData" @input="loadData"></v-pagination>
                                    </div>
                                    <div class="pb-1 pl-2 el-float-right">
                                        <v-select v-model="pager.pageSize" :items="pageSizes" label="Page Size" dense hide-details style="max-width:80px;"></v-select>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
        <v-dialog v-model="showDialog" persistent max-width="600">
            <v-card>
                <v-card-title class="headline">Department Detail</v-card-title>
                <v-card-text>
                    <v-container grid-list-sm class="pa-0">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field ref="name" label="Name" v-model="item.Name" :disabled="isEditing"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="showDialog = false">Cancel</v-btn>
                    <v-btn color="primary" :loading="isDialogBusy" @click="onDialogSave">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="isDialogBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Processing...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Constants from '../../util/Constants';

export default {
    name: 'Departments',
    props: {},
    data() {
        return {
            title: 'Department Administration',
            user: { has: () => 0 },
            ViewCompany: {},
            searchText: '',
            searchOptions: Constants.SEARCH_OPTIONS,
            searchAt: {},
            searchAtOptions: Constants.SEARCH_AT_OPTIONS,
            selected: null,
            item: {
                _id: '',
                Name: '',
                Parent_Id: []
            },
            headers: [
                { text: 'Department Name', value: 'Name', align: 'left' },
                { text: 'Action', value: 'Name', align: 'right', width: '110px', sortable: false },
            ],
            pager: {
                pageSize: 10,
                currentPage: 1,
                pages: 1,
                totalRecords: 0
            },
            pageSizes: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100],
            isBusy: false,
            showDialog: false,
            isEditing: false,
            isDialogBusy: false,
            tableData: []
        };
    },
    mounted() {
        this.$root.$on('CompanySwitched', () => {
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            this.searchText = '';
            this.loadData();
        });

        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.pager.pageSize = this.$ls.get('PageSize_Deps', 10);
        this.searchAt = this.searchAtOptions[0];
        this.loadData();
        setTimeout(() => this.$refs.search.focus(), 250);
    },
    validations() {
        return {
            item: {
                Name: {
                    required
                }
            }
        };
    },
    methods: {
        setFocus() {
            setTimeout(() => this.$refs.name.focus(), 250);
        },
        reset() {
            this.$v.$reset();
        },
        validate() {
            this.$v.$touch();
            return !this.$v.$invalid;
        },
        async loadData() {
            try {
                this.isBusy = true;
                this.searchText = this.searchText || '';
                const response = await this.$http.post('/Department/list', { search: this.searchText.trim(), searchAt: this.searchAt.value, C_Id: this.ViewCompany._id, _page: { per: this.pager.pageSize, page: this.pager.currentPage } });
                this.rawData = response.data.d;
                this.pager.totalRecords = response.data.p.t;
                this.pager.pages = response.data.p.pt;
                this.tableData = response.data.d;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data' });
            }
            finally {
                this.isBusy = false;
            }
        },
        toggleSearchAt() {
            let pos = this.searchAtOptions.indexOf(this.searchAt);
            pos += 1;
            if (pos === this.searchAtOptions.length) pos = 0;
            this.searchAt = this.searchAtOptions[pos];
            if (this.searchText.trim().length) this.loadData();
            this.$refs.search.focus();
        },
        searchChange() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.pager.currentPage = 1;
                this.loadData();
            }, 600);
        },
        onItemAdd() {
            this.reset();
            this.selected = null;
            this.item.C_Id = this.ViewCompany._id;
            this.item.Name = this.searchText || '';
            this.item.Parent_Id = '';
            // this.isEditing = false;
            this.showDialog = true;
            this.setFocus();
        },
        onItemEdit(idx, rec) {
            this.reset();
            this.selected = rec;
            this.item._id = rec._id;
            this.item.Name = rec.Name;
            this.item.Parent_Id = rec.Parent_Id;
            // this.isEditing = true;
            this.showDialog = true;
            this.setFocus();
        },
        onItemDelete(idx, rec) {
            this.$confirm({
                title: 'Delete?',
                message: 'This will delete the department. Are you sure you want to continue?'
            }, value => {
                if (value) {
                    this.isDialogBusy = true;
                    this.$http.post('/Department/save', { _id: rec._id, _x: true })
                        .then(response => {
                            if (!response.data.s) this.$alert({ type: 'error', title: 'Delete Error', message: 'An error has occurred. Please contact your systems administrator.' });
                            this.loadData();
                        })
                        .catch(err => {
                            console.error(err);
                            this.$alert({ type: 'error', title: 'Delete Error', message: `An error occurred trying to delete the data. ${err.message}` });
                        })
                        .finally(() => {
                            this.isDialogBusy = false;
                        });
                }
            });
        },
        onDialogSave() {
            if (this.validate()) {
                this.isDialogBusy = true;
                if (!this.selected) {
                    this.item._id = null;
                }
                if (this.item.Parent_Id === '') delete this.item.Parent_Id;
                this.$http.post('/Department/save', this.item)
                    .then(response => {
                        if (!response.data.s) this.$alert({ type: 'error', title: 'Save Failed', message: 'An error has occurred. Please contact your systems administrator.' });
                        this.loadData();
                        this.showDialog = false;
                    })
                    .catch(err => {
                        console.error(err);
                        this.$alert({ type: 'error', title: 'Save Error', message: `An error occurred trying to save the data. ${err.message}` });
                    })
                    .finally(() => {
                        this.isDialogBusy = false;
                    });
            }
        },
        getParentName(/* row */) {
            const names = [];
            /* for (let i = 0; i < row.P.length; i++) {
                const p = this.permissionList.find(o => o._id === row.P[i]);
                if (p) names.push(p.Name);
            } */
            return names.join(', ');
        },
        copyOne() {
            this.$alert({ type: 'info', title: 'Coming soon ...', message: 'This feature will be implemented soon.' });
        },
        copyAll() {
            this.$alert({ type: 'info', title: 'Coming soon ...', message: 'This feature will be implemented soon.' });
        }
    }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Company/Departments.vue